// import { BaseSearch, SearchBaseRequest, SearchBaseResponse } from "@tcm-modules/tcm-core.module";
import { Subject, Subscription } from "rxjs";
import { SearchBaseResponse } from "../../tcm-core.module/models/search/search-base-response";
import { SearchBaseRequest } from "../../tcm-core.module/models/search/search-base-request";
import { BaseSearch } from "../../tcm-core.module/components/base-search/base-search";
import { Directive } from "@angular/core";

@Directive()
export abstract class TcmBaseSearch<TRequest extends SearchBaseRequest, TResponse extends SearchBaseResponse<any>>
    extends BaseSearch<TRequest, TResponse>  {

    selectedRows: any[] = [];
    allRecordsCountWithActiveCheckBox = 0;
    readonly selectAllRowsToggleSubject = new Subject<boolean>();
    readonly resetSelectAllRowsSubject = new Subject<boolean>();
    readonly searchRefreshed = new Subject();

    private readonly _commonSubscriptions: Subscription[] = [];

    currentSelectionCount: number = 0;

    get isAllRowSelected() {
        if (this.viewModel == null || this.viewModel.allRecordsCountWithFilter === 0 || this.selectedRows.length === 0)
            return false;

        const selectedRecordsCount = this.selectedRows.filter(this.isSelectionCheckBoxEnabled).length;
        const allRecordsCountWithFilterCount = this.allRecordsCountWithActiveCheckBox || this.viewModel.allRecordsCountWithFilter;
        var res = allRecordsCountWithFilterCount === this.currentSelectionCount || selectedRecordsCount === allRecordsCountWithFilterCount;
        return res;
    }

    get allRecordCountWithFilter() {
        return this.viewModel.allRecordsCountWithFilter;
    }

    override ngOnDestroy() {
        super.ngOnDestroy();

        for (let s of this._commonSubscriptions) {
            s.unsubscribe();
        }
    }

    override onPagingChanged() {
        super.onPagingChanged();
        // this.selectedRows.splice(0, this.selectedRows.length);
    }

    override refresh() {
        super.refresh();
        this.currentSelectionCount = 0;
        // this.selectedRows.splice(0, this.selectedRows.length);
    }

    removeDeletedRowsFromSelection() {
        this.selectedRows.splice(0, this.selectedRows.length);
    }
    toggleAllRowsSelection(makeSelected: boolean) {
        if (this.viewModel.allRecords) {
            let records = this.viewModel.allRecords.filter(this.isSelectionCheckBoxEnabled);
            if (makeSelected) {
                if (this.selectedRows.length === 0) {
                    this.selectedRows.splice(0, this.selectedRows.length, ...records);
                }
                else {
                    var rowsToAdd = records.filter(x => !this.selectedRows.some(y => y.id === x.id));

                    this.selectedRows.push(...rowsToAdd);
                }
            } else {
                records.forEach(x => {
                    this.selectedRows.splice(this.selectedRows.indexOf(this.selectedRows.find(y => x.id === y.id)), 1);
                })
            }
            this.allRecordsCountWithActiveCheckBox = this.selectedRows.length;
            this.selectAllRowsToggleSubject.next(makeSelected);
        }
    }

    toggleRowSelection(row: any, makeSelected: boolean) {
        if (makeSelected) {
            this.selectedRows.push(row);
            this.currentSelectionCount++;
        } else {
            this.selectedRows.splice(this.selectedRows.indexOf(this.selectedRows.find(x => x.id === row.id)), 1);
            this.currentSelectionCount--;
        }
    }

    print() {
        window.print();
    }

    isSelectionCheckBoxEnabled(item: any): boolean {
        return true;
    }

    isEmptySelectionList() {
        return this.viewModel.records.filter(this.isSelectionCheckBoxEnabled).length == 0;
    }

    protected async wrapRemoteCallAsync<T = any>(executor: () => Promise<T>): Promise<T> {
        try {

            this.isLoading = true;

            const result = await executor();

            return result;
        }
        finally {
            this.isLoading = false;
        }
    }

    protected override onViewModelChanged() {
        super.onViewModelChanged();
        this.searchRefreshed.next(null);
    }

    protected addCommonSubscription(...subscriptions: Subscription[]) {
        this._commonSubscriptions.push(...subscriptions);
    }
}
